// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec1463af","732":"8b109fd6","977":"39058504"}[chunkId] + ".chunk.js";
};